import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { get } from "lodash";

//i18n
import i18n from "@./i18nMain";
import languages from "@common/languages";

const LanguageDropdown = () => {
    // Declare a new state variable, which we'll call "menu"
    const [selectedLang, setSelectedLang] = useState("");

    useEffect(() => {
        const currentLanguage = localStorage.getItem("i18nextLng");
        setSelectedLang(currentLanguage.split('-')[0]);
    }, []);

    const changeLanguageAction = lang => {
        //set language as i18n
        i18n.changeLanguage(lang);
        localStorage.setItem("i18nextLng", lang);
        setSelectedLang(lang);
    };

    const [isLanguageDropdown, setIsLanguageDropdown] = useState(false);
    const toggleLanguageDropdown = () => {
        setIsLanguageDropdown(!isLanguageDropdown);
    };
    
    return (
        <React.Fragment>
            <Dropdown id="langChoice" isOpen={isLanguageDropdown} toggle={toggleLanguageDropdown} className="ms-1 mb-2 mb-xl-0 topbar-head-dropdown header-item">
                <DropdownToggle className="btn btn-icon btn-plain" tag="button" caret>
					<span className="align-middle">
						<i className="ri-earth-line"></i>
						{get(languages, `${selectedLang}.label`)}
					</span>
                </DropdownToggle>
                <DropdownMenu className="notify-item language">
                    {Object.keys(languages).map(key => (
                        <DropdownItem
                            key={key}
                            onClick={() => changeLanguageAction(key)}
                            className={`notify-item ${selectedLang === key ? "active" : "none"
                                }`}
                        >
                            <span className="align-middle">
                                {get(languages, `${key}.label`)}
                            </span>
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default LanguageDropdown;